module.exports = __webpack_public_path__ + "img/money.d87c2f84.svg";